export * from './device-config.component';
